var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","display":"flex"}},[_c('img',{attrs:{"src":"https://oss.yueshiwl.com/img/1673949967376/gwbanner.png"}})])}]

export { render, staticRenderFns }